import { ActionBase } from '../../../core/store/action/ActionBase';

import { UndoDeleteConceptVersionModel } from "../../models/UndoDeleteConceptVersionModel";

export const UNDO_DELETE_CONCEPT_VERSION = '[Vocabulary] Undo Delete Concept Version';

export class UndoDeleteConceptVersionAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = UNDO_DELETE_CONCEPT_VERSION;

  constructor(public payload: { model: UndoDeleteConceptVersionModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/vocabulary/store/actions/UndoDeleteConceptVersionAction.ts